import { http } from './config'

export default {
  listandoad:() => {
    return http.get('adicionais.php')
  },
  verificaadicional:(cd, ord) => {
    
    //return http.get('adicionais_selecao.php?cd_prod='+cd+'&ordem='+ord)
    return http.get('adicionais_selecao.php?cd_prod_pai='+cd+'&ordem='+ord)
  }
}